import React, {useState} from 'react';
import {H2} from '../../../components/crousal/Headings';
import {Button, ButtonType, ButtonSize} from '../../../components/crousal/Button';


interface IProps {
    onChange: (step: number) => void;
}

export function Step3({onChange}: IProps) {
    const [steps, setSteps] = useState(true);

    function handleNext() {
        setSteps(false);
    }

    function finalStep() {
        onChange(4);
    }

    return (
        <div>
            {
                steps ? (
                    <div>
                        <H2 className="mt-6 lg:mt-10">Step 3 - Pricing</H2>
                        <div
                            className="items-center lg:mt-6 text-30 flex justify-center lg:w-2/5 text-sm lg:mx-auto text-center">
                            This sort of accounts are sold at a flat rate through our system.
                            The amount you will get for your account is “Price here”
                        </div>
                        <div className="mt-6 mb-10 text-md">
                            <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleNext}>
                                Next
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="flex justify-center text-center items-center lg:w-1/2 lg:mx-auto">
                            <img className="h-12" src={"/images/unrankedsmurfs-login/stop.png"} alt={"stop sign"}/>
                            <H2 className="ml-4">Step 3 - Not accepted type of account</H2>
                        </div>
                        <div
                            className="items-center lg:mt-6 text-30 flex justify-center lg:w-2/5 text-sm lg:mx-auto text-center">
                            We do not allow to sell Blue Essence or low Champions accounts through our website.
                            This is to protect our users from low quality botted accounts. These type of accounts will
                            never be accepted by UnrankedSmurfs
                            to protect our users.
                        </div>
                        <div className="mt-6 mb-10 text-md">
                            <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={finalStep}>
                                Next
                            </Button>
                        </div>
                    </div>
                )
            }
        </div>
    );
}
